import { useQuery } from '@tanstack/react-query';

import { ApiFnReturnType } from '@/slw/shared/query-client';

import { searchLocation } from './dealer-partner.api';
import { NominatimSearchParams } from './dealer-partner.type';

export const SEARCH_LOCATION_QUERY_KEY = 'search-location';

export const useSearchLocation = (params: NominatimSearchParams) =>
  useQuery<ApiFnReturnType<typeof searchLocation>>({
    queryKey: [SEARCH_LOCATION_QUERY_KEY, params],
    queryFn: () => searchLocation(params),
    enabled: !!params.country && !!params.state,
  });
